define('models/calendar/nutrition/serving',[
    'underscore', 'backbone', 'utils', 'mustache'
], function(_, Backbone, U, Mustache) {

    var MServing = Backbone.Model.extend({
        idAttribute: '_id',
        defaults: {
            name: "",
            qty: 1,
        },

        getNutrients: function() {
            return this.get('nutrients') || {};
        },

        getName: function() {
            return this.get('name');
        },

        getDisplayTitle: function() {
            return Mustache.render('{{{qty}}} x {{{name}}}', {
                qty: this.get('qty'),
                name: this.get('name')
            });
        },

        ////////////////
        // validation //
        ////////////////
        validation: {
            name: {
                presence: true,
            },
            qty: {
                presence: true,
            },

        },
    });

    return MServing;
});

